import { FC, createContext, useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { AuthStates, useAuth } from './authContext';
interface WebSocketContextType {
  connection: Socket;
}

export const WebSocketContext = createContext<WebSocketContextType>({} as WebSocketContextType);

export const WebSocketContextProvider: FC = ({ children }) => {
  const socketUrl = process.env.REACT_APP_SOCKET_URL;
  const auth = useAuth();
  const socket = io(socketUrl, {
    autoConnect: false
  });
  const [connection, setConnection] = useState(socket);

  useEffect(() => {
    if (auth.state === AuthStates.NotLogged) {
      if (socket.connected) {
        socket.disconnect();
      }
      return;
    }

    socket.connect();
    socket.on('connect', () => {
      console.log('web socket connection is on');
    });
    socket.on('disconnect', () => {
      console.log('web socket connection is off');
    });
    return () => {
      socket.disconnect();
    };
  }, [auth.state]);
  return (
    <WebSocketContext.Provider
      value={{
        connection
      }}>
      {children}
    </WebSocketContext.Provider>
  );
};
